var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHexagone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.33331L4 4.57331V8.99998L0 6.99998V2.33331Z",
    fill: "#02F3A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.66669L4 4.57335V9.00002L8 7.00002V2.66669Z",
    fill: "#7829F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0L0 2.33333L4 4.66667L8 2.66667L4 0Z",
    fill: "#9E62FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagone);
export default __webpack_public_path__ + "static/media/hexagone.7ea54dfbedf0ac6b9f5a82fcdf2233d8.svg";
export { ForwardRef as ReactComponent };